import React from "react";
import {
  Building, Store, Hotel, HeartPulse, Factory, Briefcase,
  Dumbbell, HardHat, Sparkles, Car, Stethoscope, Landmark,
} from "lucide-react";
import { propertyTypes } from "../../mock";
import Reveal from "../Reveal";

const icons = [Building, Store, Hotel, HeartPulse, Factory, Briefcase, Dumbbell, HardHat, Sparkles, Car, Stethoscope, Landmark];

export default function PropertyTypesSection() {
  return (
    <section className="py-24 bg-[#0b1f3a] text-white relative overflow-hidden">
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#c6a15b]/10 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[#c6a15b]/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Who We Serve</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl mt-3">
            Clients We're Privileged to Serve
          </h2>
          <p className="mt-4 text-slate-300 text-lg">
            We finance a broad range of property types across all 50 states.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {propertyTypes.map((t, i) => {
            const Icon = icons[i % icons.length];
            return (
              <Reveal key={t.name} delay={(i % 3) * 80}>
                <div className="group flex items-center gap-4 rounded-xl bg-white/5 ring-1 ring-white/10 p-5 hover:bg-white/10 hover:ring-[#c6a15b]/40 transition-all">
                  <div className="h-12 w-12 rounded-lg bg-[#c6a15b]/15 flex items-center justify-center shrink-0 group-hover:bg-[#c6a15b] transition-colors">
                    <Icon className="h-6 w-6 text-[#c6a15b] group-hover:text-[#0b1f3a] transition-colors" />
                  </div>
                  <div>
                    <div className="font-semibold">{t.name}</div>
                    <div className="text-sm text-slate-400">{t.note}</div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
